import * as session from './session'
import moment from 'moment'

export let Id0 = "00000000-0000-0000-0000-000000000000"
export let DateFormat = "DD/MM/YYYY"

export function RequestHeaders() {
    return {
        'Authorization': 'Bearer ' + session.Token(),
        "RequestId": Guid(),
    }
}
export function RequestConfig() {
    return { headers: RequestHeaders() }
}

//screen
export function ScreenWidth() {
    return window.innerWidth
}
export function ScreenHeight() {
    return window.innerHeight
}

export function IsMobile() {
    return /Android|iPhone|iPad|iPod/i.test(navigator.userAgent)
    //return ScreenWidth() <= ScreenHeight()
}

//message
export function OK(message, content) {
    message.success(content)
}
export function Warning(message, content) {
    message.warning(content)
}
export function Error(message, content) {
    message.error(content)
}

export function NoThing() {
    return true
}

//string
export function ToString(value) {
    let result = ""
    try {
        result = value.toString()
    }
    catch (err) {
        NoThing()
    }
    return result
}
export function ToLower(value) {
    let result = ToString(value)
    try {
        result = result.toLowerCase()
    }
    catch (err) {
        NoThing()
    }
    return result
}
export function ToUpper(value) {
    let result = ToString(value)
    try {
        result = result.toUpperCase()
    }
    catch (err) {
        NoThing()
    }
    return result
}

export function Trim(value) {
    let result = ToString(value)
    try {
        result = result.trim()
    }
    catch (err) {
        NoThing()
    }
    return result
}
export function Trim2Space(value) {
    value = Trim(value)
    return Replace(value, "  ", " ")
}
export function TrimNoSpace(value) {
    value = Trim(value)
    return Replace(value, " ", "")
}

export function TrimObject(obj) {
    Object.keys(obj).forEach(function (key) {
        if (NotNull(obj[key])) {
            if (IsObject(obj[key])) {
                TrimObject(obj[key])
            }
            else if (IsArray(obj[key])) {
                for (let i = 0; i < obj[key].length; i++) {
                    TrimObject(obj[key][i])
                }
            }
            else {
                obj[key] = Trim2Space(obj[key])
            }
        }
    })
}

//Null
export function NotNull(value) {
    if (IsArray(value))
        return (value != null) && (value != undefined) && (value.length > 0)
    else if (IsObject(value))
        return (value != null) && (value != undefined)
    else
        return (value != null) && (value != undefined) && (Trim(value) != '')
}
export function NotNullOrSpace(value) {
    return (value != null) && (value != undefined) && (value != '')
}
export function Null(value) {
    return !NotNull(value)
}

export function Selected(value) {
    value = Trim(value)
    return NotNull(value) && (value != '0') && (value != 0) && (value != Id0)
}
export function NotSelected(value) {
    return !Selected(value)
}

//True
export function True(value) {
    return NotNull(value) && (value == true || ToLower(value) == "true" || value == "1" || value == 1)
}
export function False(value) {
    return NotNull(value) && (value == false || ToLower(value) == "false" || value == "0" || value == 0)
}

export function NullOrTrue(value) {
    return Null(value) || True(value)
}
export function NullOrFalse(value) {
    return Null(value) || False(value)
}


//EQ
export function EQ(A, B) {
    let result = false
    try {
        if (Null(A) && Null(B))
            result = true
        else if (NotNull(A) && NotNull(B))
            result = A.toString().toLowerCase() == B.toString().toLowerCase()
    }
    catch (err) {
        NoThing()
    }
    return result
}
export function Diff(A, B) {
    return !EQ(A, B)
}

export function EQExact(A, B) {
    let result = false
    try {
        if (NotNull(A) && NotNull(B))
            result = A.toString() == B.toString()
    }
    catch (err) {
        NoThing()
    }
    return result
}
export function DiffExact(A, B) {
    return !EQExact(A, B)
}

export function Contains(value, text) {
    let result = false
    try {
        if (NotNull(value) && (NotNullOrSpace(text) || text == "\r\n" || text == "\n")) {
            result = value.toString().toLowerCase().indexOf(text.toString().toLowerCase()) !== -1
        }
    }
    catch (err) {
        NoThing()
    }
    return result
}
export function StartsWith(value, text) {
    let result = false
    try {
        if (NotNull(value) && NotNullOrSpace(text)) {
            result = value.toString().toLowerCase().indexOf(text.toString().toLowerCase()) == 0
        }
    }
    catch (err) {
        NoThing()
    }
    return result
}
export function EndsWith(value, text) {
    let result = false
    try {
        if (NotNull(value) && NotNullOrSpace(text)) {
            result = value.toString().toLowerCase().indexOf(text.toString().toLowerCase(), value.toString().length - text.toString().length) !== -1
        }
    }
    catch (err) {
        NoThing()
    }
    return result
}

export function EQContains(value, text) {
    return EQ(value, text)
        || Contains(value, " " + text + " ")
        || StartsWith(value, text + " ")
        || EndsWith(value, " " + text)
}

//EQ Object
export function EQObject(A, B) {
    let result = false
    try {
        if (IsString(A) && IsString(B)) {
            if (NotNull(A) && NotNull(B))
                result = A.toString().toLowerCase() == B.toString().toLowerCase()
        }
        else if (IsObject(A) && IsObject(B)) {
            if (A != null && A != 'undefined' && B != null && B != 'undefined')
                result = ObjectToJson(A).toLowerCase() == ObjectToJson(B).toLowerCase()
        }
    }
    catch (err) {
        NoThing()
    }
    return result
}
export function DiffObject(A, B) {
    return !EQObject(A, B)
}

export function EQObjectExact(A, B) {
    let result = false
    try {
        if (IsString(A) && IsString(B)) {
            if (NotNull(A) && NotNull(B))
                result = A.toString() == B.toString()
        }
        else if (IsObject(A) && IsObject(B)) {
            if (A != null && A != 'undefined' && B != null && B != 'undefined')
                result = ObjectToJson(A) == ObjectToJson(B)
        }
    }
    catch (err) {
        NoThing()
    }
    return result
}
export function DiffObjectExact(A, B) {
    return !EQObjectExact(A, B)
}

//Replace, Remove
export function Replace(value, oldText, newText) {
    value = value.toString()
    oldText = oldText.toString()
    newText = newText.toString()

    if (NotNull(value)) {
        while (value.indexOf(oldText) !== -1) {
            value = value.replace(oldText, newText)
        }
    }
    return value
}
export function Remove(value, oldText) {
    return Replace(value, oldText, "")
}

export function RemoveFirst(value, text) {
    value = ToString(value)
    text = ToString(text)
    if (StartsWith(value, text)) {
        value = value.substr(text.length, value.length - 1)
    }
    return value;
}
export function RemoveLast(value, text) {
    value = ToString(value)
    text = ToString(text)
    if (EndsWith(value, text)) {
        value = value.substr(0, value.length - text.length)
    }
    return value;
}

export function Crop(value, max) {
    value = Trim(value)
    if (value.length > max) {
        value = value.substring(0, max - 1) + '...'
    }
    return value
}

//Valid
export function ValidLength(value, min, max) {
    let result = false
    value = Trim(value)
    if (NotNull(value)) {

        let validMin = NotNull(min) ? value.length >= ToNumber(min) : true
        let validMax = NotNull(max) ? value.length <= ToNumber(max) : true
        result = validMin && validMax
    }
    else {
        result = Null(min) || ToNumber(min) == 0
    }
    return result
}
export function ValidRange(value, min, max) {
    let result = false
    value = Trim(value)
    value = ToNumberTBX(value)

    if (NotNull(value)) {
        let validMin = NotNull(min) ? value >= ToNumber(min) : true
        let validMax = NotNull(max) ? value <= ToNumber(max) : true
        result = validMin && validMax
    }
    else {
        result = Null(min) || ToNumber(min) == 0
    }
    return result
}

export function ValidUrl(value) {
    return StartsWith(value, "http://") || StartsWith(value, "https://")
}
export function ValidUrlFB(value) {
    return StartsWith(value, "https://facebook.com/") || StartsWith(value, "https://www.facebook.com/")
}

export function ValidEmail(value) {
    value = Trim(value)

    if (ValidLength(value, 6, 128)) {
        let regEx = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
        return regEx.test(value)
    }
    return false
}
export function ValidPhone(value) {
    value = Trim(value)
    return ValidNumber(value)
        && ValidLength(value, 10, 10)

        && (StartsWith(value, "09") || StartsWith(value, "08")
            || StartsWith(value, "03") || StartsWith(value, "05") || StartsWith(value, "07"))
}

export function ValidUserName(value) {
    let result = false
    if (GetAppConfig().UseEmail) {
        result = ValidEmail(value)
    }
    else {
        if (ValidLength(value, 2, 30)) {
            let regEx = new RegExp(/^[a-zA-Z0-9.]+$/)
            result = regEx.test(value)
        }
    }
    return result;
}
export function ValidPassword(value) {
    value = Trim(value)
    return ValidLength(value, 6, 30)
}

export function ValidName(value) {
    value = Trim(value)
    return ValidLength(value, 2, 30)
}

//Number
export function ValidNumber(value) {
    return NotNull(value) && !isNaN(value)
}

export function GetOnlyNumber(value) {
    value = Trim(value)

    let regex = /[^\d,-]/g
    value = value.replace(regex, '')

    return value
}
export function GetOnlyDecimal(value) {
    value = Trim(value)

    let regex = /[^\d,.-]/g
    value = value.replace(regex, '')

    return value
}

export function GetInteger(value) {
    value = Trim(value)
    let array = value.split('.')
    return array[0]
}

export function FormatNumber(value, type) {
    type = ToLower(type)
    if (StartsWith(type, "number") || StartsWith(type, "decimal")) {

        value = Trim(value)
        if (NotNull(value)) {

            if (StartsWith(type, "number"))
                value = GetInteger(value)

            //regex
            let regex = /[^\d,-]/g
            if (StartsWith(type, "decimal"))
                regex = /[^\d,.-]/g
            value = value.replace(regex, '')

            //-
            let negative = false
            if (Contains(value, "-")) {
                negative = true
                value = Replace(value, "-", "")
            }

            let decimal = false
            if (Contains(value, ".")) {
                decimal = true
            }

            //,
            value = Remove(value, ",")
            if (!decimal) {
                if (!EndsWith(type, "-no-split"))
                    value = Split1000(value)
            }
            else {
                let array = value.split('')
                value = ""

                let commed = false
                for (let i = 0; i < array.length; i++) {

                    if (array[i] != ".")
                        value += array[i]
                    else if (!commed) {
                        commed = true
                        value += array[i]
                    }
                }

                array = value.split('.')

                if (!EndsWith(type, "-no-split"))
                    value = Split1000(array[0]) + "." + array[1]
                else
                    value = array[0] + "." + array[1]
            }

            //-
            if (negative)
                value = "-" + value
        }
    }
    return value
}
export function Split1000(value) {
    value = Trim(value)

    var isNegative = StartsWith(value, "-");
    value = RemoveFirst(value, "-");

    let needSplit = value.length > 3
    if (needSplit) {

        let array = value.split('').reverse()
        value = ""

        for (let i = 0; i < array.length; i++) {
            value += array[i]

            let x = i + 1
            if (x >= 3 && x < array.length && x % 3 == 0)
                value += ","
        }
        value = value.split("").reverse().join("")
    }

    if (isNegative)
        value = "-" + value;
    return value
}

export function Split1000Dot(value) {
    value = Split1000(value)
    value = Replace(value, ",", "@")
    value = Replace(value, ".", ",")
    value = Replace(value, "@", ".")
    return value
}

export function ReCorrectDecimal(value) {
    if (Contains(value, ".")) {
        value = RemoveLast(value, "0")
        value = RemoveLast(value, ".")
    }
    return ToNumber(value)
}
export function FixNumber2(value) {
    value = ToNumberTBX(value)
    value = value.toFixed(2)
    value = ReCorrectDecimal(value)
    return value
}

export function ToNumber(value) {
    return ValidNumber(value) ? Number(value) : 0
}
export function ToNumberTBX(value) {
    value = Remove(value, ",")
    return ToNumber(value)
}

export function ConvertMoney(exRateA, exRateB, valueB) {
    exRateA = ToNumberTBX(exRateA)
    exRateB = ToNumberTBX(exRateB)
    valueB = ToNumberTBX(valueB)

    if (exRateA != 0)
        return FixNumber2(exRateB / exRateA * valueB)
    else
        return 0
}

//phone
export function FormatPhone(value) {
    if (!ValidPhone(value))
        return ""

    value = Trim(value)
    return value.substring(0, 4)
        + "-" + value.substring(4, 7)
        + "-" + value.substring(7, 10);
}

//DateTime
export function FormatDateTime(value) {
    value = Trim(value)
    if (NotNull(value))
        return moment(String(value)).format('DD/MM/YYYY HH:mm:ss')
}
export function FormatDate(value) {
    value = Trim(value)
    if (NotNull(value))
        return moment(String(value)).format('DD/MM/YYYY')
}
export function FormatTime(value) {
    value = FormatDateTime(value)
    return value = GetAfter_Text_End(value, " ")
}
export function ConvertDate(value) {
    //"2020-03-14T00:00:00"
    let result = null

    value = Trim(value)
    if (NotNull(value)) {

        value = Replace(value, "-", "/")
        if (Contains(value, "/")) {

            let array = value.split("T")
            value = array[0]

            array = value.split("/")
            result = moment.utc(array[2] + "/" + array[1] + "/" + array[0], DateFormat)
        }
    }
    return result
}

//Object, Json, Array
export function ObjectToJson(obj) {
    return JSON.stringify(obj)
}
export function JsonToObject(json) {
    try {
        return JSON.parse(json)
    }
    catch (err) {
        return null
    }
}
export function CopyObject(obj) {
    return JsonToObject(ObjectToJson(obj))
}

export function IsArray(value) {
    return Array.isArray(value)
}
export function IsObject(value) {
    return typeof value === 'object'
}
export function IsString(value) {
    return typeof value === 'string'
}

export function ToArray(value, text) {
    let result = []
    value = Trim(value)

    if (Contains(value, text))
        result = value.split(text)
    else
        result = [value]

    for (let i = 0; i < result.length; i++)
        result[i] = Trim(result[i])

    return result
}
export function BrToArray(value) {
    if (Contains(value, "\r\n")) {
        return ToArray(value, "\r\n")
    }
    else if (Contains(value, "\n")) {
        return ToArray(value, "\n")
    }
    else {
        return [value]
    }
}
export function FilterArray(array) {
    for (let i = 0; i < array.length; i++) {
        if (array[i] == null) {
            array.splice(i, 1)
            i--
        }
    }
}

export function FilterDDL(array, RelationId, EQValue) {
    let result = []
    if (NotNull(array))
        for (let i = 0; i < array.length; i++) {

            let validRelationId = NotSelected(RelationId) || EQ(array[i].RelationId, RelationId)
            let validEQ = Null(EQValue) || EQ(array[i].EQValue, EQValue)

            if (validRelationId && validEQ) {
                result.push(array[i])
            }
        }
    return result
}

export function ArrayContains(array, value) {
    let result = false
    for (let i = 0; i < array.length; i++) {
        if (EQ(array[i], value)) {
            result = true
            break
        }
    }
    return result
}

//Element
export function FullScreen() {
    Click("btnFullScreen")
    Scroll("EndPage")
}

export function ShowLoading() {
    Click("btnShowLoading")
}
export function HideLoading() {
    Click("btnHideLoading")
}

export function Element(value) {
    return document.getElementById(value)
}
export function Exists(value) {
    return NotNull(Element(value))
}

export function FirstElementByClass(name) {
    let result = null
    try {
        let DIVs = document.getElementsByClassName(name)
        if (DIVs.length > 0)
            result = DIVs[0]
    }
    catch (err) {
        NoThing()
    }
    return result
}
export function ExistsByClass(name) {
    return FirstElementByClass(name) != null
}

export function Width(value) {
    if (value == "Screen")
        return ScreenWidth()
    else if (Exists(value))
        return Element(value).offsetWidth
    else
        return 0
}
export function Height(value) {
    if (value == "Screen")
        return ScreenHeight()
    else if (Exists(value))
        return Element(value).offsetHeight
    else
        return 0
}

export function Click(value) {
    if (Exists(value))
        Element(value).click()
}
export function Scroll(value) {
    if (Exists(value))
        Element(value).scrollIntoView()
}

export function Hide(value) {
    if (Exists(value))
        Element(value).style.display = "none"
}
export function Show(value) {
    if (Exists(value))
        Element(value).style.display = ""
}

export function Disable(value) {
    if (Exists(value)) {
        Element(value).disabled = true

        let nodes = Element(value).getElementsByTagName('input');
        for (let i = 0; i < nodes.length; i++) {
            nodes[i].disabled = true;
        }
    }
}
export function RemoveElementById(value) {
    if (Exists(value))
        RemoveElement(Element(value))
}
export function RemoveElement(element) {
    try {
        element.parentNode.removeChild(element)
    }
    catch (err) {
        NoThing()
    }
}

export function RemoveEvent(element) {
    try {
        let elClone = element.cloneNode(true)
        element.parentNode.replaceChild(elClone, element)
    }
    catch (err) {
        NoThing()
    }
}

export function GetHdf(id) {
    if (Exists(id + 'Hdf'))
        return Element(id + 'Hdf').value

    if (window.AppData) {
        const value = window.AppData[id]

        if (value !== undefined)
            return typeof value === 'string'
                ? value
                : JSON.stringify(value)
    }

    return null
}

export function SetHdf(id, value) {
    if (Exists(id + 'Hdf')) {
        Element(id + 'Hdf').value = value
        return
    }

    if (!window.AppData)
        window.AppData = {}

    try {
        window.AppData[id] = typeof value === 'string'
            ? JSON.parse(value)
            : value
    }
    catch {
        window.AppData[id] = value
    }
}

export function SetCache(name, value) {
    try {
        localStorage.setItem(name, ObjectToJson(value))
    }
    catch (err) {
        NoThing()
    }
}
export function GetCache(name) {
    let result = null
    try {
        result = JsonToObject(localStorage.getItem(name))
    }
    catch (err) {
        NoThing()
    }
    return result
}

export function SetCache2(name, value) {
    try {
        localStorage.setItem(name, value)
    }
    catch (err) {
        NoThing()
    }
}
export function GetCache2(name) {
    let result = null
    try {
        result = localStorage.getItem(name)
    }
    catch (err) {
        NoThing()
    }
    return result
}

export function ClearCache(name) {
    try {
        localStorage.removeItem(name)
    }
    catch (err) {
        NoThing()
    }
}
export function ClearAllCache() {
    try {
        localStorage.clear()
    }
    catch (err) {
        NoThing()
    }
}

//Config
export function GetIndexConfig(module, entity, option) {
    let result = ""

    if (Null(module))
        module = "@"

    if (Null(option))
        option = 1

    if (NotNull(entity)) {
        let Configs = JsonToObject(GetHdf('Index'))
        if (NotNull(Configs)) {
            for (let i = 0; i < Configs.length; i++) {
                if (EQ(Configs[i].Option, option) && EQ(Configs[i].Entity.Name, entity) && (EQ(Configs[i].Entity.Module, module) || EQ(module, "@"))) {
                    result = Configs[i]
                    break
                }
            }
        }
    }
    return result
}
export function GetUIConfig() {
    return JsonToObject(GetHdf('UI'))
}

export function GetAppConfig() {
    return JsonToObject(GetHdf('App'))
}

//Component
export function GetComponent(array, name) {
    let result = null
    for (let i = 0; i < array.length; i++) {
        if (array[i].name == name) {
            result = array[i].com.default || array[i].com.default
            break
        }
    }
    return result
}

export function DirectiveDisable(el, binding) {
    if (binding.value) {
        DirectiveDisableElement(el)
    }
}
export function DirectiveDisableElementById(id) {
    if (Exists(id)) {
        DirectiveDisableElement(Element(id))
    }
}

export function DirectiveDisableElement(el) {
    let entity = GetATT(el, "id")

    const Childs = GetChildElements(el, entity)
    for (let x = 0; x < Childs.length; x++) {

        DirectiveDisableElementAndRemove(Childs[x])
        Childs[x].addEventListener("click", function () {
            DirectiveDisableElementAndRemove(Childs[x])
        });
    }
}
export function DirectiveDisableElementAndRemove(el) {
    try {
        if (EQContains(el.className, "NoDisable"))
            return

        //TBX
        if (EQContains(el.className, "ant-input") && !Contains(el.className, " ant-input-disabled"))
            el.className += " ant-input-disabled NoClick"

        if (EQContains(el.className, "ant-input-number") && !Contains(el.className, " ant-input-number-disabled"))
            el.className += " ant-input-number-disabled NoClick"

        //BTN
        if (EQContains(el.className, "ant-btn") && !Contains(el.className, " ant-btn-disabled"))
            el.className += " ant-btn-disabled NoClick"

        //icon
        if (EQContains(el.className, "anticon") && !Contains(el.className, " NoClick"))
            el.className += " NoClick"

        //DDL
        if (EQContains(el.className, "ant-select-enabled") && !Contains(el.className, "ant-select-disabled"))
            el.className = Replace(el.className, "ant-select-enabled", "ant-select-disabled NoClick")

        //CBX
        //ant-checkbox-wrapper ant-checkbox-wrapper-checked
        if (EQContains(el.className, "ant-checkbox-wrapper") && !Contains(el.className, " ant-checkbox-wrapper-disabled"))
            el.className += " ant-checkbox-wrapper-disabled NoClick"

        if (EQContains(el.className, "ant-checkbox") && !Contains(el.className, " ant-checkbox-disabled"))
            el.className += " ant-checkbox-disabled NoClick"

        if (EQContains(el.className, "ant-checkbox-input") && !Contains(el.className, " ant-checkbox-input-disabled"))
            el.className += " ant-checkbox-input-disabled NoClick"

        //calendar
        if (EQContains(el.className, "ant-calendar-picker-clear")
            || EQContains(el.className, "ant-calendar-picker-icon")) {
            RemoveElement(el)
        }
    }
    catch (err) {
        NoThing()
    }

    try {
        el.disabled = true
    }
    catch (err) {
        NoThing()
    }
}

export function GetChildElements(el, entity) {
    let result = []
    _getChildElements(el, entity, result)
    return result
}
export function _getChildElements(el, entity, result) {
    if (EQContains(el.className, "NoDisable"))
        return

    let Childs = el.childNodes
    for (let x = 0; x < Childs.length; x++) {

        if (!EQContains(Childs[x].className, "NoDisable")) {
            let valid = false

            let id = GetATT(Childs[x], "id")
            if (Null(id))
                valid = true
            else if (id == entity) {
                valid = true
            }
            else if (!StartsWith(id, "Index-Container-"))
                valid = true

            if (valid) {
                result.push(Childs[x])
                _getChildElements(Childs[x], entity, result)
            }
        }
    }
}

export function GetATT(element, att) {
    try {
        return element.getAttribute(att)
    }
    catch (err) {
        return null
    }
}

//Property
export function GetProperty(data, property, type) {
    let result = ""

    if (!IsArray(property))
        property = ToArray(property, ".")

    for (let i = 0; i < property.length; i++) {
        if (i == 0)
            result = data[property[i]]
        else if (NotNull(result))
            result = result[property[i]]
    }

    type = ToLower(type)
    if (type == "datetime")
        result = FormatDateTime(result)
    else if (type == "date")
        result = FormatDate(result)
    else
        result = FormatNumber(result, type)

    return result
}
export function SetProperty(data, property, value) {
    let newValue = CopyObject(value)

    if (!IsArray(property))
        property = ToArray(property, ".")

    let length = property.length
    if (length == 1)
        data[property[0]] = newValue
    else if (length == 2)
        data[property[0]][property[1]] = newValue
    else if (length == 3)
        data[property[0]][property[1]][property[2]] = newValue
    else if (length == 4)
        data[property[0]][property[1]][property[2]][property[3]] = newValue
    else if (length == 5)
        data[property[0]][property[1]][property[2]][property[3]][property[4]] = newValue
    else if (length == 6)
        data[property[0]][property[1]][property[2]][property[3]][property[4]][property[5]] = newValue
    else if (length == 7)
        data[property[0]][property[1]][property[2]][property[3]][property[4]][property[5]][property[6]] = newValue
    else if (length == 8)
        data[property[0]][property[1]][property[2]][property[3]][property[4]][property[5]][property[6]][property[7]] = newValue
    else if (length == 9)
        data[property[0]][property[1]][property[2]][property[3]][property[4]][property[5]][property[6]][property[7]][property[8]] = newValue
    else if (length == 10)
        data[property[0]][property[1]][property[2]][property[3]][property[4]][property[5]][property[6]][property[7]][property[8]][property[9]] = newValue
}

//ArrayProperty
export function GetArrayProperty(data, array, index, property, type) {
    let result = GetProperty(data, array, null)

    if (NotNull(result))
        result = result[index]

    return GetProperty(result, property, type)
}
export function SetArrayProperty(data, array, index, property, value) {
    let newValue = CopyObject(value)

    if (!IsArray(array))
        array = ToArray(array, ".")

    if (!IsArray(property))
        property = ToArray(property, ".")

    let arrayLength = array.length
    let propertyLength = property.length

    //1
    if (arrayLength == 1) {
        if (propertyLength == 1)
            data[array[0]][index][property[0]] = newValue
        else if (propertyLength == 2) {
            data[array[0]][index][property[0]][property[1]] = newValue
        }
        else if (propertyLength == 3)
            data[array[0]][index][property[0]][property[1]][property[2]] = newValue
        else if (propertyLength == 4)
            data[array[0]][index][property[0]][property[1]][property[2]][property[3]] = newValue
        else if (propertyLength == 5)
            data[array[0]][index][property[0]][property[1]][property[2]][property[3]][property[4]] = newValue
        else if (propertyLength == 6)
            data[array[0]][index][property[0]][property[1]][property[2]][property[3]][property[4]][property[5]] = newValue
        else if (propertyLength == 7)
            data[array[0]][index][property[0]][property[1]][property[2]][property[3]][property[4]][property[5]][property[6]] = newValue
        else if (propertyLength == 8)
            data[array[0]][index][property[0]][property[1]][property[2]][property[3]][property[4]][property[5]][property[6]][property[7]] = newValue
        else if (propertyLength == 9)
            data[array[0]][index][property[0]][property[1]][property[2]][property[3]][property[4]][property[5]][property[6]][property[7]][property[8]] = newValue
        else if (propertyLength == 10)
            data[array[0]][index][property[0]][property[1]][property[2]][property[3]][property[4]][property[5]][property[6]][property[7]][property[8]][property[9]] = newValue
    }
    //2
    else if (arrayLength == 2) {
        if (propertyLength == 1)
            data[array[0]][array[1]][index][property[0]] = newValue
        else if (propertyLength == 2)
            data[array[0]][array[1]][index][property[0]][property[1]] = newValue
        else if (propertyLength == 3)
            data[array[0]][array[1]][index][property[0]][property[1]][property[2]] = newValue
        else if (propertyLength == 4)
            data[array[0]][array[1]][index][property[0]][property[1]][property[2]][property[3]] = newValue
        else if (propertyLength == 5)
            data[array[0]][array[1]][index][property[0]][property[1]][property[2]][property[3]][property[4]] = newValue
        else if (propertyLength == 6)
            data[array[0]][array[1]][index][property[0]][property[1]][property[2]][property[3]][property[4]][property[5]] = newValue
        else if (propertyLength == 7)
            data[array[0]][array[1]][index][property[0]][property[1]][property[2]][property[3]][property[4]][property[5]][property[6]] = newValue
        else if (propertyLength == 8)
            data[array[0]][array[1]][index][property[0]][property[1]][property[2]][property[3]][property[4]][property[5]][property[6]][property[7]] = newValue
        else if (propertyLength == 9)
            data[array[0]][array[1]][index][property[0]][property[1]][property[2]][property[3]][property[4]][property[5]][property[6]][property[7]][property[8]] = newValue
        else if (propertyLength == 10)
            data[array[0]][array[1]][index][property[0]][property[1]][property[2]][property[3]][property[4]][property[5]][property[6]][property[7]][property[8]][property[9]] = newValue
    }
    //3
    else if (arrayLength == 3) {
        if (propertyLength == 1)
            data[array[0]][array[1]][array[2]][index][property[0]] = newValue
        else if (propertyLength == 2)
            data[array[0]][array[1]][array[2]][index][property[0]][property[1]] = newValue
        else if (propertyLength == 3)
            data[array[0]][array[1]][array[2]][index][property[0]][property[1]][property[2]] = newValue
        else if (propertyLength == 4)
            data[array[0]][array[1]][array[2]][index][property[0]][property[1]][property[2]][property[3]] = newValue
        else if (propertyLength == 5)
            data[array[0]][array[1]][array[2]][index][property[0]][property[1]][property[2]][property[3]][property[4]] = newValue
        else if (propertyLength == 6)
            data[array[0]][array[1]][array[2]][index][property[0]][property[1]][property[2]][property[3]][property[4]][property[5]] = newValue
        else if (propertyLength == 7)
            data[array[0]][array[1]][array[2]][index][property[0]][property[1]][property[2]][property[3]][property[4]][property[5]][property[6]] = newValue
        else if (propertyLength == 8)
            data[array[0]][array[1]][array[2]][index][property[0]][property[1]][property[2]][property[3]][property[4]][property[5]][property[6]][property[7]] = newValue
        else if (propertyLength == 9)
            data[array[0]][array[1]][array[2]][index][property[0]][property[1]][property[2]][property[3]][property[4]][property[5]][property[6]][property[7]][property[8]] = newValue
        else if (propertyLength == 10)
            data[array[0]][array[1]][array[2]][index][property[0]][property[1]][property[2]][property[3]][property[4]][property[5]][property[6]][property[7]][property[8]][property[9]] = newValue
    }
    //4
    else if (arrayLength == 3) {
        if (propertyLength == 1)
            data[array[0]][array[1]][array[2]][array[3]][index][property[0]] = newValue
        else if (propertyLength == 2)
            data[array[0]][array[1]][array[2]][array[3]][index][property[0]][property[1]] = newValue
        else if (propertyLength == 3)
            data[array[0]][array[1]][array[2]][array[3]][index][property[0]][property[1]][property[2]] = newValue
        else if (propertyLength == 4)
            data[array[0]][array[1]][array[2]][array[3]][index][property[0]][property[1]][property[2]][property[3]] = newValue
        else if (propertyLength == 5)
            data[array[0]][array[1]][array[2]][array[3]][index][property[0]][property[1]][property[2]][property[3]][property[4]] = newValue
        else if (propertyLength == 6)
            data[array[0]][array[1]][array[2]][array[3]][index][property[0]][property[1]][property[2]][property[3]][property[4]][property[5]] = newValue
        else if (propertyLength == 7)
            data[array[0]][array[1]][array[2]][array[3]][index][property[0]][property[1]][property[2]][property[3]][property[4]][property[5]][property[6]] = newValue
        else if (propertyLength == 8)
            data[array[0]][array[1]][array[2]][array[3]][index][property[0]][property[1]][property[2]][property[3]][property[4]][property[5]][property[6]][property[7]] = newValue
        else if (propertyLength == 9)
            data[array[0]][array[1]][array[2]][array[3]][index][property[0]][property[1]][property[2]][property[3]][property[4]][property[5]][property[6]][property[7]][property[8]] = newValue
        else if (propertyLength == 10)
            data[array[0]][array[1]][array[2]][array[3]][index][property[0]][property[1]][property[2]][property[3]][property[4]][property[5]][property[6]][property[7]][property[8]][property[9]] = newValue
    }
    //5
    else if (arrayLength == 3) {
        if (propertyLength == 1)
            data[array[0]][array[1]][array[2]][array[3]][array[4]][index][property[0]] = newValue
        else if (propertyLength == 2)
            data[array[0]][array[1]][array[2]][array[3]][array[4]][index][property[0]][property[1]] = newValue
        else if (propertyLength == 3)
            data[array[0]][array[1]][array[2]][array[3]][array[4]][index][property[0]][property[1]][property[2]] = newValue
        else if (propertyLength == 4)
            data[array[0]][array[1]][array[2]][array[3]][array[4]][index][property[0]][property[1]][property[2]][property[3]] = newValue
        else if (propertyLength == 5)
            data[array[0]][array[1]][array[2]][array[3]][array[4]][index][property[0]][property[1]][property[2]][property[3]][property[4]] = newValue
        else if (propertyLength == 6)
            data[array[0]][array[1]][array[2]][array[3]][array[4]][index][property[0]][property[1]][property[2]][property[3]][property[4]][property[5]] = newValue
        else if (propertyLength == 7)
            data[array[0]][array[1]][array[2]][array[3]][array[4]][index][property[0]][property[1]][property[2]][property[3]][property[4]][property[5]][property[6]] = newValue
        else if (propertyLength == 8)
            data[array[0]][array[1]][array[2]][array[3]][array[4]][index][property[0]][property[1]][property[2]][property[3]][property[4]][property[5]][property[6]][property[7]] = newValue
        else if (propertyLength == 9)
            data[array[0]][array[1]][array[2]][array[3]][array[4]][index][property[0]][property[1]][property[2]][property[3]][property[4]][property[5]][property[6]][property[7]][property[8]] = newValue
        else if (propertyLength == 10)
            data[array[0]][array[1]][array[2]][array[3]][array[4]][index][property[0]][property[1]][property[2]][property[3]][property[4]][property[5]][property[6]][property[7]][property[8]][property[9]] = newValue
    }
    //6
    else if (arrayLength == 3) {
        if (propertyLength == 1)
            data[array[0]][array[1]][array[2]][array[3]][array[4]][array[5]][index][property[0]] = newValue
        else if (propertyLength == 2)
            data[array[0]][array[1]][array[2]][array[3]][array[4]][array[5]][index][property[0]][property[1]] = newValue
        else if (propertyLength == 3)
            data[array[0]][array[1]][array[2]][array[3]][array[4]][array[5]][index][property[0]][property[1]][property[2]] = newValue
        else if (propertyLength == 4)
            data[array[0]][array[1]][array[2]][array[3]][array[4]][array[5]][index][property[0]][property[1]][property[2]][property[3]] = newValue
        else if (propertyLength == 5)
            data[array[0]][array[1]][array[2]][array[3]][array[4]][array[5]][index][property[0]][property[1]][property[2]][property[3]][property[4]] = newValue
        else if (propertyLength == 6)
            data[array[0]][array[1]][array[2]][array[3]][array[4]][array[5]][index][property[0]][property[1]][property[2]][property[3]][property[4]][property[5]] = newValue
        else if (propertyLength == 7)
            data[array[0]][array[1]][array[2]][array[3]][array[4]][array[5]][index][property[0]][property[1]][property[2]][property[3]][property[4]][property[5]][property[6]] = newValue
        else if (propertyLength == 8)
            data[array[0]][array[1]][array[2]][array[3]][array[4]][array[5]][index][property[0]][property[1]][property[2]][property[3]][property[4]][property[5]][property[6]][property[7]] = newValue
        else if (propertyLength == 9)
            data[array[0]][array[1]][array[2]][array[3]][array[4]][array[5]][index][property[0]][property[1]][property[2]][property[3]][property[4]][property[5]][property[6]][property[7]][property[8]] = newValue
        else if (propertyLength == 10)
            data[array[0]][array[1]][array[2]][array[3]][array[4]][array[5]][index][property[0]][property[1]][property[2]][property[3]][property[4]][property[5]][property[6]][property[7]][property[8]][property[9]] = newValue
    }
    //7
    else if (arrayLength == 3) {
        if (propertyLength == 1)
            data[array[0]][array[1]][array[2]][array[3]][array[4]][array[5]][array[6]][index][property[0]] = newValue
        else if (propertyLength == 2)
            data[array[0]][array[1]][array[2]][array[3]][array[4]][array[5]][array[6]][index][property[0]][property[1]] = newValue
        else if (propertyLength == 3)
            data[array[0]][array[1]][array[2]][array[3]][array[4]][array[5]][array[6]][index][property[0]][property[1]][property[2]] = newValue
        else if (propertyLength == 4)
            data[array[0]][array[1]][array[2]][array[3]][array[4]][array[5]][array[6]][index][property[0]][property[1]][property[2]][property[3]] = newValue
        else if (propertyLength == 5)
            data[array[0]][array[1]][array[2]][array[3]][array[4]][array[5]][array[6]][index][property[0]][property[1]][property[2]][property[3]][property[4]] = newValue
        else if (propertyLength == 6)
            data[array[0]][array[1]][array[2]][array[3]][array[4]][array[5]][array[6]][index][property[0]][property[1]][property[2]][property[3]][property[4]][property[5]] = newValue
        else if (propertyLength == 7)
            data[array[0]][array[1]][array[2]][array[3]][array[4]][array[5]][array[6]][index][property[0]][property[1]][property[2]][property[3]][property[4]][property[5]][property[6]] = newValue
        else if (propertyLength == 8)
            data[array[0]][array[1]][array[2]][array[3]][array[4]][array[5]][array[6]][index][property[0]][property[1]][property[2]][property[3]][property[4]][property[5]][property[6]][property[7]] = newValue
        else if (propertyLength == 9)
            data[array[0]][array[1]][array[2]][array[3]][array[4]][array[5]][array[6]][index][property[0]][property[1]][property[2]][property[3]][property[4]][property[5]][property[6]][property[7]][property[8]] = newValue
        else if (propertyLength == 10)
            data[array[0]][array[1]][array[2]][array[3]][array[4]][array[5]][array[6]][index][property[0]][property[1]][property[2]][property[3]][property[4]][property[5]][property[6]][property[7]][property[8]][property[9]] = newValue
    }
    //8
    else if (arrayLength == 3) {
        if (propertyLength == 1)
            data[array[0]][array[1]][array[2]][array[3]][array[4]][array[5]][array[6]][array[7]][index][property[0]] = newValue
        else if (propertyLength == 2)
            data[array[0]][array[1]][array[2]][array[3]][array[4]][array[5]][array[6]][array[7]][index][property[0]][property[1]] = newValue
        else if (propertyLength == 3)
            data[array[0]][array[1]][array[2]][array[3]][array[4]][array[5]][array[6]][array[7]][index][property[0]][property[1]][property[2]] = newValue
        else if (propertyLength == 4)
            data[array[0]][array[1]][array[2]][array[3]][array[4]][array[5]][array[6]][array[7]][index][property[0]][property[1]][property[2]][property[3]] = newValue
        else if (propertyLength == 5)
            data[array[0]][array[1]][array[2]][array[3]][array[4]][array[5]][array[6]][array[7]][index][property[0]][property[1]][property[2]][property[3]][property[4]] = newValue
        else if (propertyLength == 6)
            data[array[0]][array[1]][array[2]][array[3]][array[4]][array[5]][array[6]][array[7]][index][property[0]][property[1]][property[2]][property[3]][property[4]][property[5]] = newValue
        else if (propertyLength == 7)
            data[array[0]][array[1]][array[2]][array[3]][array[4]][array[5]][array[6]][array[7]][index][property[0]][property[1]][property[2]][property[3]][property[4]][property[5]][property[6]] = newValue
        else if (propertyLength == 8)
            data[array[0]][array[1]][array[2]][array[3]][array[4]][array[5]][array[6]][array[7]][index][property[0]][property[1]][property[2]][property[3]][property[4]][property[5]][property[6]][property[7]] = newValue
        else if (propertyLength == 9)
            data[array[0]][array[1]][array[2]][array[3]][array[4]][array[5]][array[6]][array[7]][index][property[0]][property[1]][property[2]][property[3]][property[4]][property[5]][property[6]][property[7]][property[8]] = newValue
        else if (propertyLength == 10)
            data[array[0]][array[1]][array[2]][array[3]][array[4]][array[5]][array[6]][array[7]][index][property[0]][property[1]][property[2]][property[3]][property[4]][property[5]][property[6]][property[7]][property[8]][property[9]] = newValue
    }
    //9
    else if (arrayLength == 3) {
        if (propertyLength == 1)
            data[array[0]][array[1]][array[2]][array[3]][array[4]][array[5]][array[6]][array[7]][array[8]][index][property[0]] = newValue
        else if (propertyLength == 2)
            data[array[0]][array[1]][array[2]][array[3]][array[4]][array[5]][array[6]][array[7]][array[8]][index][property[0]][property[1]] = newValue
        else if (propertyLength == 3)
            data[array[0]][array[1]][array[2]][array[3]][array[4]][array[5]][array[6]][array[7]][array[8]][index][property[0]][property[1]][property[2]] = newValue
        else if (propertyLength == 4)
            data[array[0]][array[1]][array[2]][array[3]][array[4]][array[5]][array[6]][array[7]][array[8]][index][property[0]][property[1]][property[2]][property[3]] = newValue
        else if (propertyLength == 5)
            data[array[0]][array[1]][array[2]][array[3]][array[4]][array[5]][array[6]][array[7]][array[8]][index][property[0]][property[1]][property[2]][property[3]][property[4]] = newValue
        else if (propertyLength == 6)
            data[array[0]][array[1]][array[2]][array[3]][array[4]][array[5]][array[6]][array[7]][array[8]][index][property[0]][property[1]][property[2]][property[3]][property[4]][property[5]] = newValue
        else if (propertyLength == 7)
            data[array[0]][array[1]][array[2]][array[3]][array[4]][array[5]][array[6]][array[7]][array[8]][index][property[0]][property[1]][property[2]][property[3]][property[4]][property[5]][property[6]] = newValue
        else if (propertyLength == 8)
            data[array[0]][array[1]][array[2]][array[3]][array[4]][array[5]][array[6]][array[7]][array[8]][index][property[0]][property[1]][property[2]][property[3]][property[4]][property[5]][property[6]][property[7]] = newValue
        else if (propertyLength == 9)
            data[array[0]][array[1]][array[2]][array[3]][array[4]][array[5]][array[6]][array[7]][array[8]][index][property[0]][property[1]][property[2]][property[3]][property[4]][property[5]][property[6]][property[7]][property[8]] = newValue
        else if (propertyLength == 10)
            data[array[0]][array[1]][array[2]][array[3]][array[4]][array[5]][array[6]][array[7]][array[8]][index][property[0]][property[1]][property[2]][property[3]][property[4]][property[5]][property[6]][property[7]][property[8]][property[9]] = newValue
    }
    //10
    else if (arrayLength == 3) {
        if (propertyLength == 1)
            data[array[0]][array[1]][array[2]][array[3]][array[4]][array[5]][array[6]][array[7]][array[8]][array[9]][index][property[0]] = newValue
        else if (propertyLength == 2)
            data[array[0]][array[1]][array[2]][array[3]][array[4]][array[5]][array[6]][array[7]][array[8]][array[9]][index][property[0]][property[1]] = newValue
        else if (propertyLength == 3)
            data[array[0]][array[1]][array[2]][array[3]][array[4]][array[5]][array[6]][array[7]][array[8]][array[9]][index][property[0]][property[1]][property[2]] = newValue
        else if (propertyLength == 4)
            data[array[0]][array[1]][array[2]][array[3]][array[4]][array[5]][array[6]][array[7]][array[8]][array[9]][index][property[0]][property[1]][property[2]][property[3]] = newValue
        else if (propertyLength == 5)
            data[array[0]][array[1]][array[2]][array[3]][array[4]][array[5]][array[6]][array[7]][array[8]][array[9]][index][property[0]][property[1]][property[2]][property[3]][property[4]] = newValue
        else if (propertyLength == 6)
            data[array[0]][array[1]][array[2]][array[3]][array[4]][array[5]][array[6]][array[7]][array[8]][array[9]][index][property[0]][property[1]][property[2]][property[3]][property[4]][property[5]] = newValue
        else if (propertyLength == 7)
            data[array[0]][array[1]][array[2]][array[3]][array[4]][array[5]][array[6]][array[7]][array[8]][array[9]][index][property[0]][property[1]][property[2]][property[3]][property[4]][property[5]][property[6]] = newValue
        else if (propertyLength == 8)
            data[array[0]][array[1]][array[2]][array[3]][array[4]][array[5]][array[6]][array[7]][array[8]][array[9]][index][property[0]][property[1]][property[2]][property[3]][property[4]][property[5]][property[6]][property[7]] = newValue
        else if (propertyLength == 9)
            data[array[0]][array[1]][array[2]][array[3]][array[4]][array[5]][array[6]][array[7]][array[8]][array[9]][index][property[0]][property[1]][property[2]][property[3]][property[4]][property[5]][property[6]][property[7]][property[8]] = newValue
        else if (propertyLength == 10)
            data[array[0]][array[1]][array[2]][array[3]][array[4]][array[5]][array[6]][array[7]][array[8]][array[9]][index][property[0]][property[1]][property[2]][property[3]][property[4]][property[5]][property[6]][property[7]][property[8]][property[9]] = newValue
    }
}

export function AddArrayProperty(data, array, value) {
    let newValue = CopyObject(value)

    if (!IsArray(array))
        array = ToArray(array, ".")

    let arrayLength = array.length
    if (arrayLength == 1)
        data[array[0]].push(newValue)
    else if (arrayLength == 2)
        data[array[0]][array[1]].push(newValue)
    else if (arrayLength == 3)
        data[array[0]][array[1]][array[2]].push(newValue)
    else if (arrayLength == 4)
        data[array[0]][array[1]][array[2]][array[3]].push(newValue)
    else if (arrayLength == 5)
        data[array[0]][array[1]][array[2]][array[3]][array[4]].push(newValue)
    else if (arrayLength == 6)
        data[array[0]][array[1]][array[2]][array[3]][array[4]][array[5]].push(newValue)
    else if (arrayLength == 7)
        data[array[0]][array[1]][array[2]][array[3]][array[4]][array[5]][array[6]].push(newValue)
    else if (arrayLength == 8)
        data[array[0]][array[1]][array[2]][array[3]][array[4]][array[5]][array[6]][array[7]].push(newValue)
    else if (arrayLength == 9)
        data[array[0]][array[1]][array[2]][array[3]][array[4]][array[5]][array[6]][array[7]][array[8]].push(newValue)
    else if (arrayLength == 10)
        data[array[0]][array[1]][array[2]][array[3]][array[4]][array[5]][array[6]][array[7]][array[8]][array[9]].push(newValue)
}
export function RemoveArrayProperty(data, array, index) {
    if (!IsArray(array))
        array = ToArray(array, ".")

    let arrayLength = array.length
    if (arrayLength == 1)
        data[array[0]].splice(index, 1)
    else if (arrayLength == 2)
        data[array[0]][array[1]].splice(index, 1)
    else if (arrayLength == 3)
        data[array[0]][array[1]][array[2]].splice(index, 1)
    else if (arrayLength == 4)
        data[array[0]][array[1]][array[2]][array[3]].splice(index, 1)
    else if (arrayLength == 5)
        data[array[0]][array[1]][array[2]][array[3]][array[4]].splice(index, 1)
    else if (arrayLength == 6)
        data[array[0]][array[1]][array[2]][array[3]][array[4]][array[5]].splice(index, 1)
    else if (arrayLength == 7)
        data[array[0]][array[1]][array[2]][array[3]][array[4]][array[5]][array[6]].splice(index, 1)
    else if (arrayLength == 8)
        data[array[0]][array[1]][array[2]][array[3]][array[4]][array[5]][array[6]][array[7]].splice(index, 1)
    else if (arrayLength == 9)
        data[array[0]][array[1]][array[2]][array[3]][array[4]][array[5]][array[6]][array[7]][array[8]].splice(index, 1)
    else if (arrayLength == 10)
        data[array[0]][array[1]][array[2]][array[3]][array[4]][array[5]][array[6]][array[7]][array[8]][array[9]].splice(index, 1)
}

export function PrintElement(id) {
    if (Exists(id)) {
        let newWindow = window.open('', 'Print')

        newWindow.document.open()
        newWindow.document.write('<html><body onload="window.print()"><table border="0" style="width: 100%"><tr><td align="center">' + Element(id).innerHTML + '</td></tr></table></body></html>')
        newWindow.document.close()

        setTimeout(function () {
            newWindow.close()
        }, 1000 * 0.1)
    }
}

export function GoTo(url) {
    window.location = url
}
export function Reload() {
    GoTo(window.location)
}
export function GoHome() {
    GoTo("/")
}

export function GoLogin() {
    let goBack = window.location.pathname + window.location.search
    if (Null(goBack) || EQ(goBack, "/") || EQ(goBack, "/Login"))
        GoTo("/Login")
    else
        GoTo("/Login?GoBack=" + EncodeUrl(goBack))
}
export function GoChangePassword() {
    let goBack = GetQuery("GoBack")
    if (Null(goBack))
        goBack = window.location.pathname + window.location.search

    if (Null(goBack) || EQ(goBack, "/") || EQ(goBack, "/Login"))
        GoTo("/ChangePassword")
    else
        GoTo("/ChangePassword?GoBack=" + EncodeUrl(goBack))
}
export function GoBack() {
    let goBack = GetQuery("GoBack")
    if (Null(goBack))
        GoHome()
    else
        GoTo(goBack)
}

export function EncodeUrl(url) {
    return encodeURI(url)
}
export function DecodeUrl(url) {
    return decodeURI(url)
}

export function GetQuery(name) {
    let url = window.location.href
    //name = name.replace(/[[]]/g, '\\$&')

    let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
    let results = regex.exec(url)

    if (!results) return null
    if (!results[2]) return ''

    return decodeURIComponent(results[2].replace(/\+/g, ' '))
}
//export function GetQuery(name) {
//    let params = (new URL(document.location)).searchParams;
//    return ToString(params.get(name))
//}

//NEW
export function Guid() {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
}

export function GetQueryTrue(name) {
    return True(GetQuery(name))
}
export function GetQueryNumber(name) {
    return ToNumber(GetQuery(name))
}

export function AddJs(file) {
    if (!EndsWith(file, ".js"))
        file += ".js";

    let plugin = document.createElement("script");
    plugin.setAttribute("type", "text/javascript");
    plugin.setAttribute("src", "/Asset/" + file + "?" + new Date());
    document.head.appendChild(plugin);
}
export function AddCss(file) {
    if (!EndsWith(file, ".css"))
        file += ".css";

    let plugin = document.createElement("link");
    plugin.setAttribute("rel", "stylesheet");
    plugin.setAttribute("href", "/Asset/" + file + "?" + new Date());
    document.head.appendChild(plugin);
}

export function DateTime(addMinutes) {
    if (Null(addMinutes))
        addMinutes = 0

    return new Date(Number(document.getElementById("ServerTime").content) + addMinutes * 60000)
}
export function DDMMYY(addMinutes) {
    return Day(addMinutes) + "/" + Month(addMinutes) + "/" + Year(addMinutes)
}

export function Day(addMinutes) {
    return DateTime(addMinutes).getDate()
}
export function Month(addMinutes) {
    return DateTime(addMinutes).getMonth()
}
export function Year(addMinutes) {
    return DateTime(addMinutes).getFullYear()
}

export function Hour(addMinutes) {
    return DateTime(addMinutes).getHours()
}
export function Minute(addMinutes) {
    return DateTime(addMinutes).getMinutes()
}
export function Second(addMinutes) {
    return DateTime(addMinutes).getSeconds()
}

export function CropHttp(value) {
    value = RemoveFirst(value, "http://")
    value = RemoveFirst(value, "https://")
    value = RemoveFirst(value, "www.")
    return value
}

export function GetBefore_Text_End(value, endText) {
    value = value.xTrim();

    if (Contains(value, endText)) {
        let endIndex = value.indexOf(endText);
        value = value.substr(endIndex);
    }
    return value;
}
export function RemoveAfter_Text_End(value, endText) {
    value = value.xTrim();

    if (Contains(value, endText)) {
        let endIndex = value.indexOf(endText);
        value = value.substr(0, endIndex);
    }
    return value;
}

export function GetAfter_Text_End(value, endText) {
    value = GetBefore_Text_End(value, endText);
    value = RemoveFirst(value, endText);
    return value;
}
export function RemoveBefore_Text_End(value, endText) {
    value = RemoveAfter_Text_End(value, endText);
    value = RemoveLast(value, endText);
    return value;
}

export function GetBetween(value, startText, endText) {
    value = GetAfter_Text_End(value, startText);
    value = RemoveBefore_Text_End(value, endText);
    return value;
}

export function GetBefore_Text_End2(value, endText) {
    value = value.xTrim();

    if (Contains(value, endText)) {
        let endIndex = value.lastIndexOf(endText);
        value = value.substr(endIndex);
    }
    return value;
}
export function RemoveAfter_Text_End2(value, endText) {
    value = value.xTrim();

    if (Contains(value, endText)) {
        let endIndex = value.lastIndexOf(endText);
        value = value.substr(0, endIndex);
    }
    return value;
}

export function GetAfter_Text_End2(value, endText) {
    value = GetBefore_Text_End2(value, endText);
    value = RemoveFirst(value, endText);
    return value;
}
export function RemoveBefore_Text_End2(value, endText) {
    value = RemoveAfter_Text_End2(value, endText);
    value = RemoveLast(value, endText);
    return value;
}

export function GetBetween2(value, startText, endText) {
    value = GetAfter_Text_End2(value, startText);
    value = RemoveBefore_Text_End2(value, endText);
    return value;
}

export function IsEmbeding() {
    return True(GetHdf("IsEmbeding"))
}